import { type Enum } from '@webapp/infrastructure/types/Enum'

// Which target the detail card acts on (Feature-Set-local UI state)
export const ReportAccessDetailModes = {
  SINGLE_SECONDARY_CATEGORY: 'single-secondary-category',
  ALL_SECONDARY_CATEGORIES: 'all-secondary-categories', // every SecondaryCategory in one PrimaryCategory
  ALL_PRIMARY_CATEGORIES: 'all-primary-categories', // tenant-wide
} as const

export type ReportAccessDetailModeEnum = Enum<typeof ReportAccessDetailModes>
